import type { GetRecurringFeeChargesOneResponse } from '@Common/types/bo/recurring_fee_charges';

export const b2bRecurringFeeChargesTranslations = {
  title: 'Frais récurrents B2B',
  sections: {
    details: 'Détails',
    linked_orders: 'Fee charge orders',
    paid_by_company: "Payé par l'entreprise",
    paid_by_user: "Payé par l'adhérent",
  },
  types: {
    b2b_custody_fee: 'Frais de tenue de compte',
    b2b_management_fee: 'Frais de gestion',
  } satisfies Record<GetRecurringFeeChargesOneResponse['type'], string>,
  statuses: {
    new: 'Nouveau',
    executed: 'Executé',
    insufficient_funds: 'Fonds insuffisants',
    initiated: 'Initié',
    skipped: 'Ignoré',
  } satisfies Record<GetRecurringFeeChargesOneResponse['status'], string>,
  paid_by_values: {
    company: 'Entreprise',
    user: 'Adhérent',
  } satisfies Record<GetRecurringFeeChargesOneResponse['paid_by'], string>,
  charge_frequencies: {
    monthly: 'Mensuelle',
    quarterly: 'Trimestrielle',
    yearly: 'Annuelle',
  } satisfies Record<GetRecurringFeeChargesOneResponse['charge_frequency'], string>,
  fields: {
    id: 'ID Frais récurrent Recurring',
    b2b_company_plan_type: 'Plan',
    user_id: 'ID Utilisateur',
    paid_by: 'Payé par',
    type: 'Type',
    status: 'Statut',
    amount_current_period: 'Montant facturé pour la période en cours',
    charge_frequency: 'Fréquence de facturation',
    amount_past_uncharged_periods: 'Montant facturé pour les périodes passées non facturées,',
    date: 'Date de début',
    end_date: 'Date de fin',
    currency: 'Devise',
    created_at: 'Créé à',
  } satisfies Record<keyof GetRecurringFeeChargesOneResponse, string>,
};
